import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRadarComponent } from './simple-icons-radar.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRadarComponent ],
    exports:      [ SimpleIconsRadarComponent ],
    bootstrap:    []
})
export class SimpleIconsRadarModule {}
